// uiarc: dialog/drawer kapatma düğmesi (32px kare, `radius-control`, basınca 0.96, bırakınca yay).
// Dialog ve Sheet aynı düğmeyi paylaşır; üstteki başlığın ilk satırına hizalanır (konum çağıranın `className`'inde;
// `absolute` verilirse `relative`'in yerini alır).
import { Dialog as DialogPrimitive } from '@base-ui/react/dialog'
import { XIcon } from 'lucide-react'
import { messages } from '@/lib/messages'
import { cn } from '@/lib/utils'

function OverlayClose({ className, ...props }: DialogPrimitive.Close.Props) {
  return (
    <DialogPrimitive.Close
      data-slot="overlay-close"
      aria-label={messages.common.close}
      className={cn(
        'border-border bg-surface-muted/50 text-text-secondary rounded-control relative grid size-8 cursor-pointer place-items-center border [-webkit-tap-highlight-color:transparent]',
        // Dokunmatikte 32 px parmakla zor vuruluyordu: görünüm aynı, dokunma alanı 44 px.
        "pointer-coarse:after:absolute pointer-coarse:after:-inset-1.5 pointer-coarse:after:content-['']",
        '[transition:background-color_var(--duration-fast)_var(--ease-standard),color_var(--duration-fast)_var(--ease-standard),transform_var(--duration-spring)_var(--ease-spring)]',
        'hover:bg-surface-muted hover:text-foreground',
        'active:scale-[0.96] active:[transition:background-color_var(--duration-fast)_var(--ease-standard),color_var(--duration-fast)_var(--ease-standard),transform_var(--duration-instant)_var(--ease-standard)]',
        'motion-reduce:transition-none motion-reduce:active:scale-100',
        className,
      )}
      {...props}
    >
      <XIcon className="size-4" strokeWidth={1.75} aria-hidden="true" />
    </DialogPrimitive.Close>
  )
}

export { OverlayClose }
